import React from 'react';
import { pick, prop } from 'ramda';

import { Button } from '@core/js/components/common/Button';
import { Icon } from '@core/js/components/common/Icon';
import { Logo } from '@core/js/components/main/DefaultHeader/components/Logo';

import { MyBalance } from '@theme/js/components/main/DefaultHeader/components/MyBalance/MyBalance';

import * as hooks from '@core/js/components/main/DefaultHeader/hooks';
import { useComponentTranslations } from '@core/js/hooks/component/useComponentTranslations';
import { useAppSelector, usePageSelector, useUserSelector } from '@core/js/store/hooks';

import { useHandleToggleLeftMenu } from '@interlayer/js/components/main/DefaultHeader/sun/helper';
import { AUTOMATED_TEST_IDS } from '@interlayer/js/custom/constants';
import { clsx } from '@interlayer/js/utils/classNames.util';

import style from './MobileHeader.scss';

export const MobileHeader: React.FC = () => {
    const translate = useComponentTranslations();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const onLoginButtonClick = hooks.useOnLoginButtonClick();
    const { overrideMenu, menuWcId } = usePageSelector(pick(['overrideMenu', 'menuWcId']));
    const hideSideMenuIcon = overrideMenu && !menuWcId;
    const { registrationURL } = useAppSelector(pick(['registrationURL']));
    const { handleToggleLeftMenu, isOpenLeftMenu } = useHandleToggleLeftMenu();

    return (
        <div className={style.header}>
            <div className={style.info}>
                {!hideSideMenuIcon && (
                    <Icon
                        type={isOpenLeftMenu ? 'close' : 'sideMenu'}
                        onClick={handleToggleLeftMenu}
                        className={clsx(style.menu, 'cms-icon-side-menu', { [style.isOpenedSideMenu]: isOpenLeftMenu })}
                        aria-label={translate('header.sideMenu.aria-label')}
                    />
                )}

                <Logo />
            </div>

            <div className={style.controls}>
                {isLoggedIn
                    ? (
                        <MyBalance className={style.balance} />
                    )
                    : (
                        <>
                            {registrationURL && (
                                <Button
                                    color="negative"
                                    href={registrationURL}
                                    className={clsx(style.headerBtn, style.registration)}
                                >
                                    {translate('login.button.join_now')}
                                </Button>
                            )}

                            <Button
                                color="success"
                                className={clsx(style.headerBtn, AUTOMATED_TEST_IDS.login)}
                                onClick={onLoginButtonClick}
                            >
                                {translate('login.button.loginHeader')}
                            </Button>
                        </>
                    )
                }
            </div>
        </div>
    );
};
